export default {
    comparisonOptions: {
        leftType: "itemId",
        rightType: "constantValue",
        rightValue: "",
        operator: "equals",
        id: 0
    },
    conditionState: true,
    type: "comparison",
    operator: "equals"
}